import React from "react";
import "../styles/DashboardAccessBlocked.css";

const DashboardAccessBlocked = ({ dueDate, onRetry }) => {
  return (
    <div className="dashboard-access-blocked">
      <div className="dashboard-access-blocked__card">
        <h1>Dashboard access paused</h1>
        <p>
          Your EnViz dashboard subscription is inactive. Please contact support
          to renew access.
        </p>
        {dueDate && (
          <p className="dashboard-access-blocked__due">
            Billing due date: <strong>{dueDate}</strong>
          </p>
        )}
        {onRetry && (
          <button type="button" className="dashboard-access-blocked__retry" onClick={onRetry}>
            Check again
          </button>
        )}
      </div>
    </div>
  );
};

export default DashboardAccessBlocked;
